<template>
  <div class="personnel-add">
    <FormInfo :formData="formData" :isEdit="false"></FormInfo>
  </div>
</template>

<script>
import FormInfo from "./role-form";

export default {
  data() {
    return {
      formData: null
    };
  },
  created() {
    //异步发送数据
    setTimeout(() => {
      this.formData = {
        name: "",
        desp: "",
        column_ids: [],
        id: ""
      };
    });
  },
  components: {
    FormInfo
  },
  methods: {}
};
</script>

<style lang="less" scoped>
</style>